import React from "react";
import {Redirect, Route} from "react-router-dom";

export default ({component: ChildComponent, props: appProps, ...rest}) =>
  <Route
    {...rest}
    render={props => {

      let redirect = "";
      if (props.location.search.length > 0 || props.location.pathname.length > 1) {
        redirect = props.location.pathname + props.location.search;
        if (redirect === "/logout") redirect = "";
      }

      return appProps.isAuthenticated
        ? <ChildComponent {...props} {...appProps} />
        : (
          redirect.length > 1
            ? <Redirect to={`/login?redirect=${redirect}`}/>
            : <Redirect to={`/login`}/>
        )
    }
    }
  />;



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRoute.js